import { ref } from 'vue';
import { BlobServiceClient } from '@azure/storage-blob';
import gameActivityAPI from '@/api/gameActivityAPI';
import api from '@/api';
import profileConfig from '@/api/profile';

export function useGameThumbnailUpload() {
    const isUploading = ref(false);
    const uploadError = ref('');

    const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
    const MAX_SIZE_MB = 2;

    const validateFile = (file) => {
        if (!ALLOWED_TYPES.includes(file.type)) {
            return '只支援 JPG、PNG、WEBP 格式';
        }
        if (file.size > MAX_SIZE_MB * 1024 * 1024) {
            return `圖片大小不能超過 ${MAX_SIZE_MB}MB`;
        }
        return null;
    };

    const uploadThumbnail = async (file, activityId) => {
        const error = validateFile(file);
        if (error) {
            uploadError.value = error;
            return null;
        }

        isUploading.value = true;
        uploadError.value = '';

        try {
            // 取得 SAS token
            const sasRes = await gameActivityAPI.getThumbnailSasToken();
            const sasToken = sasRes.data?.token || sasRes.token;

            // 建立 ContainerClient（與 useMindMapBlob 相同模式）
            const serverLocation = api.main.getServerLocation();
            const blobDomain = profileConfig.blobDomain[serverLocation];
            const containerUrl = `${blobDomain}/ht-aigame`;
            const serviceClient = new BlobServiceClient(`${containerUrl}?${sasToken}`);
            const containerClient = serviceClient.getContainerClient('');

            // 固定路徑 thumbnails/{activityId}
            const blobPath = `thumbnails/${activityId}`;
            const blockBlobClient = containerClient.getBlockBlobClient(blobPath);
            await blockBlobClient.uploadBrowserData(file, {
                blobHTTPHeaders: { blobContentType: file.type }
            });

            // URL 加 ?t=timestamp 避免快取
            const thumbnailUrl = `${containerUrl}/${blobPath}?t=${Date.now()}`;
            return thumbnailUrl;
        } catch (e) {
            uploadError.value = '上傳失敗，請稍後再試';
            console.error('縮圖上傳失敗:', e);
            return null;
        } finally {
            isUploading.value = false;
        }
    };

    return { isUploading, uploadError, validateFile, uploadThumbnail };
}
